import "core-js/modules/es.array.reverse.js";
var _class, _CompositeCatalogItem;
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { action, autorun, computed, runInAction, makeObservable } from "mobx";
import DeveloperError from "terriajs-cesium/Source/Core/DeveloperError";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import isDefined from "../../../Core/isDefined";
import Result from "../../../Core/Result";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import ModelReference from "../../../Traits/ModelReference";
import CompositeCatalogItemTraits from "../../../Traits/TraitsClasses/CompositeCatalogItemTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import { BaseModel } from "../../Definition/Model";
let CompositeCatalogItem = (_class = (_CompositeCatalogItem = class CompositeCatalogItem extends MappableMixin(CatalogMemberMixin(CreateModel(CompositeCatalogItemTraits))) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "_visibilityDisposer", autorun(() => {
      this.syncVisibilityToMembers();
    }));
    makeObservable(this);
  }
  get type() {
    return CompositeCatalogItem.type;
  }
  get typeName() {
    return i18next.t("models.composite.name");
  }
  get memberModels() {
    const members = this.members;
    if (members === undefined) {
      return [];
    }
    return filterOutUndefined(members.map(id => ModelReference.isRemoved(id) ? undefined : this.terria.getModelById(BaseModel, id)));
  }
  async forceLoadMetadata() {
    const members = this.memberModels.filter(CatalogMemberMixin.isMixedInto);
    // Avoid calling loadX functions in a computed context
    await Promise.resolve();
    Result.combine(await Promise.all(members.map(async model => await model.loadMetadata())), "Failed to load composite catalog items metadata").throwIfError();
  }
  async forceLoadMapItems() {
    const members = this.memberModels.filter(MappableMixin.isMixedInto);
    // Avoid calling loadX functions in a computed context
    await Promise.resolve();
    Result.combine(await Promise.all(members.map(model => model.loadMapItems())), "Failed to load composite catalog items mapItems").throwIfError();
  }
  syncVisibilityToMembers() {
    const {
      show
    } = this;
    this.memberModels.forEach(model => {
      runInAction(() => {
        model.setTrait(CommonStrata.underride, "show", show);
      });
    });
  }
  get mapItems() {
    const result = [];
    this.memberModels.filter(MappableMixin.isMixedInto).forEach(model => {
      result.push(...model.mapItems);
    });
    return result;
  }
  add(stratumId, member) {
    if (member.uniqueId === undefined) {
      throw new DeveloperError("A model without a `uniqueId` cannot be added to a composite.");
    }
    if (!isDefined(this.terria.getModelById(BaseModel, member.uniqueId))) {
      this.terria.addModel(member);
    }
    const members = this.getTrait(stratumId, "members");
    if (isDefined(members)) {
      members.push(member.uniqueId);
    } else {
      this.setTrait(stratumId, "members", [member.uniqueId]);
    }
  }
  dispose() {
    super.dispose();
    this._visibilityDisposer();
  }
}, _defineProperty(_CompositeCatalogItem, "type", "composite"), _CompositeCatalogItem), _applyDecoratedDescriptor(_class.prototype, "memberModels", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "memberModels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "add", [action], Object.getOwnPropertyDescriptor(_class.prototype, "add"), _class.prototype), _class);
export { CompositeCatalogItem as default };